const host = 'http://geoportal.jambikota.go.id';

export const config = {
  host: `${host}/`,
  api: `${host}/api`,
  wms: `${host}/geoserver/wms?`,
};
export default config;
